// To-do: Pending to move to our domain configuration
// Related technical debt: https://jira.ets.mpi-internal.com/browse/MTR-94346

export const IMAGE_SRC_BY_CATEGORY2_ID = {
  2910: 'https://s.ccdn.es/images/vehicles/bus@2x.png',
  2920: 'https://s.ccdn.es/images/vehicles/truck@2x.png',
  2930: 'https://s.ccdn.es/images/vehicles/van@2x.png',
  3110: 'https://s.ccdn.es/images/vehicles/classic-car@2x.png',
  3111: 'https://s.ccdn.es/images/vehicles/competition-car@2x.png',
  3820: 'https://s.ccdn.es/images/vehicles/caravan@2x.png',
  3821: 'https://s.ccdn.es/images/vehicles/autocaravan@2x.png',
  3822: 'https://s.ccdn.es/images/vehicles/trailer@2x.png'
}

export const IMAGE_SRC_BY_CATEGORY_ID = {
  2900: 'https://s.ccdn.es/images/vehicles/van-and-truck@2x.png',
  3110: 'https://s.ccdn.es/images/vehicles/classic-and-competition-car@2x.png',
  3820: 'https://s.ccdn.es/images/vehicles/caravan-and-autocaravan@2x.png'
}
